// auth-config.ts
import {
  IPublicClientApplication,
  PublicClientApplication,
  InteractionType,
  AuthenticationResult,
} from '@azure/msal-browser';
import { MsalGuardConfiguration, MsalInterceptorConfiguration, MsalService } from '@azure/msal-angular';
import { env } from '../environments/env';

export const msalConfig = {
  auth: {
    clientId: env.get().auth.clientId,
    authority: env.get().auth.authority,
    redirectUri: '/callback',
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ['User.Read'],
  extraQueryParameters: { prompt: 'select_account', domain_hint: 'none' },
};

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication(msalConfig);
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
  };
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();

  protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', ['User.Read']);
  protectedResourceMap.set(`${env.get().api.url}/*`, [env.get().auth.apiScope]);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}

// export const initializeMsalInstance = (msalInstance: PublicClientApplication) => {
//   return () => msalInstance.initialize();
//   };

export function initializeMsal(msalService: MsalService, versionCheckService?: any): () => Promise<void> {
  return async (): Promise<void> => {
    try {
      // Initialize the MSAL instance
      await msalService.instance.initialize();
      const response: AuthenticationResult | null = await msalService.instance.handleRedirectPromise();
      if (response) {
        msalService.instance.setActiveAccount(response.account);
      } else {
        const accounts = msalService.instance.getAllAccounts();
        if (accounts.length > 0) {
          msalService.instance.setActiveAccount(accounts[0]);
        } else {
          console.warn('[AUTH] No active account found');
        }
      }

      if (versionCheckService && msalService.instance.getActiveAccount()) {
        await versionCheckService.checkVersion();
      }
    } catch (error) {
      console.error('[AUTH] Error during MSAL initialization:', error);
    }
  };
}
